import React, { useEffect, useMemo } from 'react'
import {
  DeepLinkOfferModal,
  useFraudnet
} from '@paypalcorp/shopping-components'

import OmniChannelTemplate from 'components/Template/OmnichannelTemplate'
import { NO_SAVED_OFFER } from 'constants/touchpoint'
import useGraphQL from 'hooks/useGraphQL'
import { SAVED } from 'constants/link'
import { GET_SHOPPING_FEED_QUERY } from 'graphql/queries'
import { SHOPPING_FEED_TYPES } from 'graphql/constants/shoppingFeed'
import { GRAPHQL_STATUS } from 'graphql/constants/status'
import { GetShoppingFeedQuery } from 'types/graphql/queries'
import { PAGE_LOCATORS } from 'views/Shopping/constants/automation'
import RenderSectionV3 from 'views/RenderSectionV3'
import { SectionType } from 'shoplist-app/shopping/types/ShoppingPageType'
import clientData from 'lib/client-data'
import Layout from 'components/Layout'

import {
  SAVED_OFFERS_PAGE_MODULE,
  SAVED_OFFERS_PAGE_SCREEN_SHOWN
} from '../../../lib/client-constants'
import { SetupPa } from '../../../lib/track-client-side'
import PageMessages from '../components/PageMessages'
import { SAVED_TAB_TOUCHPOINT } from './constants'
import { FRAUDNET_APP_ID } from '../../../constants/fraudnet'
import { getBaseWidgetProps } from '../../../lib/widget'

const SavedOffersPage = () => {
  const {
    fetchData,
    data,
    status: fetchStatus,
    error
  } = useGraphQL<GetShoppingFeedQuery>(GET_SHOPPING_FEED_QUERY)

  useEffect(() => {
    if (clientData.isUserLoggedIn)
      fetchData({ feedType: SHOPPING_FEED_TYPES.SAVED_TAB, isPageLayout: true })
  }, [fetchData])
  const fptiSetup = useMemo<Parameters<SetupPa>>(
    () => [SAVED_OFFERS_PAGE_MODULE, SAVED_OFFERS_PAGE_SCREEN_SHOWN],
    []
  )

  const status = clientData.isUserLoggedIn ? fetchStatus : GRAPHQL_STATUS.DONE

  useFraudnet(FRAUDNET_APP_ID)

  return (
    <Layout>
      <DeepLinkOfferModal {...getBaseWidgetProps()} />
      <OmniChannelTemplate
        activeSubNavPage={SAVED.id}
        error={error}
        fptiSetup={fptiSetup}
        status={status}
        locator={PAGE_LOCATORS.SAVED_PAGE}
        isUserLoggedIn={clientData.isUserLoggedIn}
      >
        {!clientData.isUserLoggedIn ? (
          <PageMessages isUserLoggedOut />
        ) : (
          <>
            {data?.shoppingFeed?.sections?.some(
              section => section.touchpointId === NO_SAVED_OFFER
            ) || !data?.shoppingFeed?.sections?.length ? (
              <PageMessages hasNoSavedDeals />
            ) : (
              <RenderSectionV3
                layoutId={SAVED_TAB_TOUCHPOINT}
                /**
                 * TODO remove SectionType[] casting when RenderSections accept new types
                 * https://engineering.paypalcorp.com/jira/browse/DTSHOPATMS-2717
                 */
                sections={(data?.shoppingFeed?.sections as SectionType[]) || []}
              />
            )}
          </>
        )}
      </OmniChannelTemplate>
    </Layout>
  )
}

export default SavedOffersPage
